<template>
  <div class="platform-skills-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.platformSkills.title') }}</h1>
        <p>{{ $t('bo.platformSkills.subtitle') }}</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs">
      <button
        :class="['tab', activeTab === 'groups' ? 'tab-active' : '']"
        @click="activeTab = 'groups'"
      >{{ $t('bo.platformSkills.tabGroups') }}</button>
      <button
        :class="['tab', activeTab === 'skills' ? 'tab-active' : '']"
        @click="activeTab = 'skills'"
      >{{ $t('bo.platformSkills.tabSkills') }}</button>
    </div>

    <!-- Groups tab -->
    <PlatformSkillGroupsList
      v-if="activeTab === 'groups'"
      ref="groupsRef"
    />

    <!-- Skills tab -->
    <PlatformSkillsList
      v-if="activeTab === 'skills'"
      ref="skillsRef"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PlatformSkillGroupsList from './PlatformSkillGroupsList.vue'
import PlatformSkillsList from './PlatformSkillsList.vue'

const activeTab = ref('groups')
const groupsRef = ref(null)
const skillsRef = ref(null)
</script>

<style scoped>
.platform-skills-manager {
  padding: 2rem;
}

.page-header {
  margin-bottom: 1.5rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.tab {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  background: none;
  border: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}

.tab:hover {
  color: #1f2937;
}

.tab-active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}
</style>
